export default __webpack_public_path__ + "static/media/galeria_scrum01.72ba8cf0.png";